export default __webpack_public_path__ + "static/media/tariq.e4bd4827.jpg";